import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { GridStateStore } from './grid-state.store';
let GridStateQuery = class GridStateQuery extends Query {
    constructor(store) {
        super(store);
        this.store = store;
    }
    getStateForTab(tabId) {
        return this.getValue().tabs[tabId] || {};
    }
    getGridState(tabId, gridId) {
        return this.getStateForTab(tabId)[gridId];
    }
};
GridStateQuery.ctorParameters = () => [
    { type: GridStateStore }
];
GridStateQuery = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [GridStateStore])
], GridStateQuery);
export { GridStateQuery };
